import AppRoute from "models/AppRoute"
import { Purpose } from "config/constants"
import { Guid } from "@/types"

interface IOfferCreateRouteQuery {
    purpose: Purpose
    reservationId?: Guid
    offerId?: Guid
    backUrl?: string
}

const OfferCreateRoute = new AppRoute<{}, IOfferCreateRouteQuery>({
    route: "/offers/create",
    navbar: true,
    authRequired: true,
})

export default OfferCreateRoute
